import React from "react";

import { ActiveCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function active({ width, onResize }: Column.Options) {
	return base(ColumnId.Active, (item) => <Content item={item} />, {
		width,
		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default active;
